window.activateAbRst006 = () => {
	const subscriptionContainer = document.querySelectorAll('.loop-subscription-container');
	if (subscriptionContainer.length > 0) return;

	const atcButton = document.querySelector('.product__info-wrapper .product-form .product-form__buttons .product__add-to-cart[name="add"]');
	if (!atcButton) return;
	const stickyAtcButton = document.querySelector('.product-sticky-atc[data-js-rst-006-sticky-atc-container]');
	if (!stickyAtcButton) return;

	document.body.setAttribute('bs-ab-rst-006', 'true');

	stickyAtcButton.addEventListener('click', () => {
		atcButton.click();

		// custom kameleoon goal
        Kameleoon.API.Goals.processConversion(375673)
	});

	window.addEventListener('scroll', () => {
		const atcButtonPosition = atcButton.getBoundingClientRect();

		if (atcButtonPosition.top < 10) {
			stickyAtcButton.classList.add('active');
		}

		if (atcButtonPosition.top > 10) {
			stickyAtcButton.classList.remove('active');
		}
	});
};
